import React from "react";

export const BlueBox = (props: React.PropsWithChildren<any>) => {
  return <div className="blue-bg white-text s1_small padding radius" style={{ textAlign: "center" }}>
    {props.children}
  </div>;
}